import ServiceBase from '@/services/ServiceBase';
import ApiLogsSearchRequest from '@/models/requests/ApiLogsSearchRequest';
import ApiLogsResponse from '@/models/responses/ApiLogsResponse';

class ApiLogsService extends ServiceBase {

    search(request: ApiLogsSearchRequest): Promise<ApiLogsResponse> {
        return this.postWithRawResult<ApiLogsResponse>('/api/api-logs/search', request, null);
    }
}

export default new ApiLogsService(); 